import { connect } from 'react-redux'

import { getUIWindowSizesWidth } from 'store/entities/ui/selectors'
import {
  getIdentityPendingGetHistory,
  getIdentityActivitiesHistoryIsPageSingle,
  isShowFeatureDot,
} from 'store/entities/identity/selectors'

import Chart from './Chart'

const mapStateToProps = state => ({
  isMobile: getUIWindowSizesWidth(state) < 530,
  pending: getIdentityPendingGetHistory(state),
  isSingle: getIdentityActivitiesHistoryIsPageSingle(state),
  isShowFeatureDot: isShowFeatureDot(state),
})

export default connect(mapStateToProps)(Chart)
